import { Component } from 'react';

export class FiledAccountsSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;
        return (
            <svg
                className={className}
                width="45"
                height="38"
                viewBox="0 0 45 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <ellipse
                    cx="19.5234"
                    cy="31.396"
                    rx="3.16597"
                    ry="3.17131"
                    fill="#C7E5D1"
                />
                <mask id="path-2-inside-1" fill="white">
                    <rect
                        x="11.0811"
                        y="1.79706"
                        width="12.6639"
                        height="35.9415"
                        rx="1"
                    />
                </mask>
                <rect
                    x="11.0811"
                    y="1.79706"
                    width="12.6639"
                    height="35.9415"
                    rx="1"
                    stroke="#1F4264"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    mask="url(#path-2-inside-1)"
                />
                <path
                    d="M19.829 29.2818C19.829 30.6202 18.7462 31.7031 17.413 31.7031C16.0799 31.7031 14.9971 30.6202 14.9971 29.2818C14.9971 27.9433 16.0799 26.8605 17.413 26.8605C18.7462 26.8605 19.829 27.9433 19.829 29.2818Z"
                    stroke="#1F4264"
                    strokeWidth="1.5"
                />
                <line
                    x1="14.9971"
                    y1="7.38971"
                    x2="19.829"
                    y2="7.38971"
                    stroke="#1F4264"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <line
                    x1="14.9971"
                    y1="10.561"
                    x2="19.829"
                    y2="10.561"
                    stroke="#1F4264"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <line
                    x1="14.9971"
                    y1="13.7323"
                    x2="19.829"
                    y2="13.7323"
                    stroke="#1F4264"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <ellipse
                    cx="8.44283"
                    cy="31.396"
                    rx="3.16597"
                    ry="3.17131"
                    fill="#C7E5D1"
                />
                <mask id="path-8-inside-2" fill="white">
                    <rect y="1.79706" width="12.6639" height="35.9415" rx="1" />
                </mask>
                <rect
                    y="1.79706"
                    width="12.6639"
                    height="35.9415"
                    rx="1"
                    stroke="#1F4264"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    mask="url(#path-8-inside-2)"
                />
                <path
                    d="M8.74796 29.2818C8.74796 30.6202 7.6651 31.7031 6.33199 31.7031C4.99887 31.7031 3.91602 30.6202 3.91602 29.2818C3.91602 27.9433 4.99887 26.8605 6.33199 26.8605C7.6651 26.8605 8.74796 27.9433 8.74796 29.2818Z"
                    stroke="#1F4264"
                    strokeWidth="1.5"
                />
                <line
                    x1="3.91602"
                    y1="7.38971"
                    x2="8.74796"
                    y2="7.38971"
                    stroke="#1F4264"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <line
                    x1="3.91602"
                    y1="10.561"
                    x2="8.74796"
                    y2="10.561"
                    stroke="#1F4264"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <line
                    x1="3.91602"
                    y1="13.7323"
                    x2="8.74796"
                    y2="13.7323"
                    stroke="#1F4264"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <ellipse
                    rx="3.16633"
                    ry="3.17095"
                    transform="matrix(0.965817 -0.259226 0.258412 0.966035 39.2833 29.6847)"
                    fill="#C7E5D1"
                />
                <path
                    d="M24.6411 3.74831L34.9419 0.983579C35.075 0.947851 35.2115 1.02669 35.2471 1.15983L44.017 33.9446C44.0527 34.0782 43.9733 34.2158 43.8397 34.2517L33.539 37.0164C33.4059 37.0521 33.2693 36.9733 33.2337 36.8401L24.4638 4.05539C24.4281 3.92178 24.5075 3.78416 24.6411 3.74831Z"
                    stroke="#1F4264"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M39.0325 27.5633C39.3783 28.856 38.6123 30.1828 37.3244 30.5284C36.0365 30.8741 34.7108 30.1087 34.3651 28.8161C34.0193 27.5235 34.7853 26.1967 36.0732 25.851C37.3611 25.5053 38.6867 26.2707 39.0325 27.5633Z"
                    stroke="#1F4264"
                    strokeWidth="1.5"
                />
                <line
                    x1="0.75"
                    y1="-0.75"
                    x2="5.58266"
                    y2="-0.75"
                    transform="matrix(0.965817 -0.259226 0.258412 0.966035 28.1777 8.58881)"
                    stroke="#1F4264"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <line
                    x1="0.75"
                    y1="-0.75"
                    x2="5.58266"
                    y2="-0.75"
                    transform="matrix(0.965817 -0.259226 0.258412 0.966035 28.9971 11.6521)"
                    stroke="#1F4264"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <line
                    x1="0.75"
                    y1="-0.75"
                    x2="5.58266"
                    y2="-0.75"
                    transform="matrix(0.965817 -0.259226 0.258412 0.966035 29.8164 14.7153)"
                    stroke="#1F4264"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        );
    }
}
